// src/components/ScrollToTop.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Wait a tick for lazy-loaded components to render
    const scrollTimeout = setTimeout(() => {
      if (hash) {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      } else {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      }
    }, 50); // 50ms delay ensures DOM elements exist

    return () => clearTimeout(scrollTimeout);
  }, [pathname, hash]);

  return null;
}
